import React, { useContext, useCallback } from 'react';
import { useQuery } from '@apollo/client';
import MatchingSetSlider from './MatchingSetSlider/MatchingSetSlider';
import MatchingSetCard from './MatchingSetCard/MatchingSetCard';
import ProductPageContext from '../../contexts/ProductPageContext';
import BreakpointContext from '../../contexts/BreakpointContext';
import GET_MATCHING_SETS from './queries';
import MatchingSetSkeleton from './MatchingSetSkeleton/MatchingSetSkeleton';

export default function MatchingSetsWidget() {
  const ProductPageState = useContext(ProductPageContext);
  const { tmntData } = ProductPageState || {};
  const { hasMatchingSetsPdpEnabled } = ProductPageState?.collectionData || {};
  const { kicId, hasProductSets } = ProductPageState?.collectionData?.activeProduct || {};
  const shouldRequestMatchingSets = hasMatchingSetsPdpEnabled && hasProductSets;
  const { data, loading, error } = useQuery(GET_MATCHING_SETS, {
    variables: { kicId },
    skip: !shouldRequestMatchingSets || !kicId,
  });

  const breakpoints = useContext(BreakpointContext);
  const isMobile = breakpoints.xxsmall && !breakpoints.medium;

  const handleMatchingSetClick = useCallback((product, element) => {
    const quickviewData = {
      collectionId: String(product.collectionId),
      productId: String(product.productId),
      returnFocus: element,
      faceout: 'prod',
      productViewMethod: 'recommendation-matching set',
      pageViewMethod: 'recommendations',
    };

    document.dispatchEvent(
      new CustomEvent('quickview:mfe:openModal', { detail: quickviewData }),
    );
  }, []);

  if (!shouldRequestMatchingSets || error) {
    return null;
  }
  const matchingSets = data?.matchingSets;

  if (!loading && (!matchingSets || matchingSets.length === 0)) {
    return null;
  }

  return (
    <div
      className="matching-sets-widget"
      data-testid="matching-sets-widget"
    >
      <h3 className="matching-sets-widget__title h3" data-type-style="h3">
        {tmntData?.matchingSetPdpHeader?.value}
      </h3>

      {loading ? (
        <div className="matching-sets-widget__loading">
          <MatchingSetSkeleton count={3} />
        </div>
      ) : null}

      {!loading && isMobile && (
        <div key="mobile" className="matching-sets-widget__mobile-slider">
          {matchingSets.map((set, index) => (
            <div key={set.kicId} className="matching-sets-widget__mobile-slide">
              <MatchingSetCard
                image={set?.imageUrl}
                name={set?.name}
                brand={set?.brand}
                listPrice={set?.prices?.list}
                memberPrice={set?.prices?.member}
                onClick={(event) => handleMatchingSetClick(set, event.currentTarget)}
                tmntData={tmntData}
                setSlideIndex={index}
              />
            </div>
          ))}
        </div>
      )}

      {!loading && !isMobile && (
        <div key="desktop" className="matching-sets-widget__slider">
          <MatchingSetSlider
            sets={matchingSets}
            handleMatchingSetClick={handleMatchingSetClick}
          />
        </div>
      )}
    </div>
  );
}
